export default {
  'sequence.title': 'Manage Sequences',
  'sequence.pattern': 'Pattern',
  'sequence.pattern.list.currentDay': 'Current Day - ',
  'sequence.pattern.list.currentMonthNumber': 'Current Month Number - ',
  'sequence.pattern.list.currentYear': 'Current Year - ',
  'sequence.pattern.list.currentYearOnlyLastTwoDigits': 'Current Year Only Last Two Digits - ',
  'sequence.pattern.list.automaticNumbering': 'Automatic Numbering - ',
  'sequence.pattern.list.automaticNumberingRestartYearly':
    'Automatic Numbering (Yearly Restart) - ',
  'sequence.pattern.list.automaticNumberingRestartMonthly':
    'Automatic Numbering (Monthly Restart) - ',
  'sequence.pattern.list.automaticNumberingRestartDaily': 'Automatic Numbering (Daily Restart) - ',
  'sequence.pattern.list.processName': 'Process Name - ',
  'sequence.pattern.list.processGroupName': 'Process Group Name - ',
  'sequence.pattern.list.applicantFullName': 'Applicant (Full Name) - ',
  'sequence.pattern.list.applicantNames': 'Applicant (Names) - ',
  'sequence.pattern.list.applicantLastNames': 'Applicant (Last Names) - ',
  'sequence.pattern.list.applicantPosition': 'Applicant Position - ',
  'sequence.pattern.list.note':
    'Note: You must replace #D with a valid number. For example, if you want to use {`{ACNI#D}`}, you must write {`{ACNI#4}`}, where the number 4 represents the number of digits the numbering will have (0001, 0002,..0045)',
  'sequence.pattern.list.formInternalNameFieldInternalName':
    '{{Form.internal_form_name.Field.internal_field_name}}',
  'sequence.pattern.list.variableName': '{{Variable.variable_name}}',
  'sequence.pattern.list.entityEntityIdItemItemIdFieldInternalName':
    '{{Entity.entity_id.Item.item_id.Field.internal_name}}',
  'sequence.pattern.list.iterationStepDataFieldInternalName':
    '{{IterationStep.Data.internal_field_name}}',
  'sequence.automaticNumbersCurrentYear': 'Current Year - Automatic Numbering',
  'sequence.automaticNumbersCurrentMonth': 'Current Month - Automatic Numbering',
  'sequence.automaticNumbersCurrentDay': 'Current Day - Automatic Numbering',
  'sequence.lastGeneratedNumber': 'Last Generated Number',
  'sequence.rowVersion': 'Row Version',
  'sequence.creator': 'Creator',
  'sequence.modifier': 'Modifier',
  'sequence.sequenceItem': 'Subsequence',
  'sequence.generatedNumber': 'Generated Number',
  'sequence.referenceItemId': 'Reference Item ID',
  'sequence.referenceItemDescription': 'Reference Item Description',
  'sequence.referenceExtraData': 'Reference Extra Data',
};
